module.exports = __webpack_public_path__ + "img/LunHang.4db4066f.gif";